<template>
  <van-popup v-model="showBind" class="backRect" @closed="onClosed">
    <TopBar :pagetitle="title" :is-left-self="true" @leftClick="onBack" />
    <div class="rectBack">
      <FieldSelect v-model="formData.type" :list="typeList" label="类型" placeholder="请选择类型" @change="onTypeChange" />
      <van-field
        v-model="formData.body"
        required
        label="内容"
        type="textarea"
        rows="2"
        show-word-limit
        autosize
        maxlength="2048"
        placeholder="请输入投诉建议内容"
      />
      <div class="uploadRect">
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="100"
          :after-read="afterRead"
        />
      </div>
      <div class="buttonRect">
        <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onSendComplaint">提交</van-button>
      </div>
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Uploader, Button, Popup, Field, Toast } from 'vant'
import { compressorImageList, GetEnumList, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import FieldSelect from '@/components/FieldSelect'
export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    TopBar,
    FieldSelect
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
  },
  data() {
    return {
      title: '新增投诉建议',
      showBind: false,
      buttonLoading: false,
      typeList: [],
      fileList: [],
      formData: {
        body: '',
        imgs: '',
        type: ''
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.fileList = []
        setTimeout(() => {
          this.typeList = []
          this.typeList = GetEnumList('Em_ComplaintType')
          this.formData.type = ''
        }, 1)
        setTimeout(() => {
          this.formData.type = 'PROPOSAL'
        }, 10)
        this.showBind = true
      } else {
        this.showBind = false
      }
    }
  },
  created() {

  },
  methods: {
    GetEnumList,
    MyNotify,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onTypeChange(select) {
      this.formData.type = select.value
    },
    init() {

    },
    onClosed() {
      this.$emit('input', false)
    },
    onBack() {
      this.showBind = false
      return true
    },
    onSendComplaint() {
      this.buttonLoading = true
      this.uploadImg((imgStr) => {
        console.log('uploadImg', imgStr)
        this.formData.imgs = imgStr
        request({
          url: '/user/addUserComplaint',
          method: 'post',
          data: this.formData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          Toast.success('提交成功')
          this.showBind = false
          this.$emit('reload')
        })
      })
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          var list = []
          this.fileList.map(value => {
            list.push(value.url)
          })
          callback(list.toString())
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=complaint',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          this.fileList.map(value => {
            if (!value.file) {
              list.push(value.url)
            }
          })
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    afterRead(file) {
      console.log('file', file)
    }
  }
}
</script>
<style scoped>
.rectBack{
  background-color: #fff;
  margin:1em;
  border-radius: 0.4em;
  overflow: hidden;
}
.rectBack .uploadRect{
  padding: 0.5em;
}
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #F1f1f1;
}
.inputRect{
  margin: 1em 1em 0 1em;
  background-color: #fff;
  border-radius: 0.5em;
  overflow: hidden;
}
.regAbout{
  margin:1em 2em;
  color: #999;
  font-size: 0.8em;
}
</style>
